import { navItems } from '../../app/nav'
import { NavItem } from '../ui/nav-item'
import { useAuthStore } from '../../stores/auth'
import { useAlertPhase } from '../../hooks/useAlertPhase'
import { cn } from '../../lib/utils'

export function SideNav() {
  const token = useAuthStore((s) => s.token)
  const phase = useAlertPhase()
  return (
    <aside className="fixed bottom-0 left-0 top-[5.75rem] z-30 hidden w-56 border-r border-border bg-surface px-3 py-4 lg:block">
      <nav className="space-y-1">
        {navItems.map((item) => {
          if (item.requiresAuth && !token) return null
          return <NavItem key={item.to} to={item.to} icon={item.icon} label={item.label} />
        })}
      </nav>
      <div className="absolute inset-x-3 bottom-4">
        <div
          className={cn(
            'flex items-start gap-2 rounded-lg border bg-black/20 p-3 text-[10px] leading-4 text-muted-foreground/60',
            phase === 'CRITICAL' && 'border-critical/50',
          )}
        >
          <span
            aria-hidden="true"
            className={cn(
              'mt-1 size-1.5 shrink-0 rounded-full',
              phase === 'CRITICAL' && 'bg-critical animate-pulse',
              phase === 'ALERT' && 'bg-warning',
              phase === 'WATCH' && 'bg-watch',
              phase === 'IDLE' && 'bg-muted-foreground/40',
            )}
          />
          <span>
            SEVEN · 天穹应急响应网络
            <br />
            数据来源：天穹·枢实时链路
          </span>
        </div>
      </div>
    </aside>
  )
}
